export default {
  "apples": 100, 
  "oranges": 50, 
  "pears": 150, 
  "banana": 75
}